import { CartDraft, LineItemDraft } from '@commercetools/platform-sdk';
import { TENANT_STORAGE_KEY } from '@constants/tenant';
import { isFeatureEnabled, FEATURES } from './featureFlags';
import Cookies from 'js-cookie';

export const getCartDraft = (lineItemDraft: LineItemDraft, currency = 'USD'): CartDraft => ({
  country: 'US',
  currency,
  lineItems: [ lineItemDraft ],
  ...(isFeatureEnabled(FEATURES.MULTI_TENANCY) && { storeKey: JSON.parse(Cookies.get(TENANT_STORAGE_KEY))?.key })
});
